import { defineStore } from 'pinia'
import axios from 'axios'

interface CompaniesState {
  dateUpdated: Date | null
  companyList: Company[]
}

interface MainStoreState {
  token: string
  refreshToken: string
  currentUserName: string
  query: string
  companies: CompaniesState
  lastTokenUpdate: Date | null
  drawerOpen: boolean
}

export const useMainStore = defineStore('main', {
  state: (): MainStoreState => ({
    token: '',
    refreshToken: '',
    currentUserName: '',
    query: '',
    companies: {
      dateUpdated: null,
      companyList: [],
    },
    lastTokenUpdate: null,
    drawerOpen: true,
  }),

  getters: {
    getQuery: (state) => () => state.query,
    getToken: (state) => state.token,
  },

  actions: {
    login(payload: string | { access: string; refresh: string }) {
      if (typeof payload === 'string') {
        // Обратная совместимость: если передали строку, это access токен
        this.token = payload
      } else {
        // Новый формат: объект с access и refresh токенами
        this.token = payload.access
        this.refreshToken = payload.refresh
      }
      this.lastTokenUpdate = new Date()
    },

    async logout() {
      this.token = ''
      this.refreshToken = ''
      this.lastTokenUpdate = null
    },

    async setQuery(query: string) {
      this.query = query
    },

    async setCurrentUserName(userName: string) {
      this.currentUserName = userName
    },

    async getCompanies(): Promise<Company[]> {
      if (
        !this.companies.dateUpdated ||
        new Date().getTime() - new Date(this.companies.dateUpdated).getTime() > 3600000
      ) {
        const items = (await axios.get('/api/companies/')).data as PagedList<Company>
        this.companies = {
          dateUpdated: new Date(),
          companyList: items.results,
        }
      }
      return this.companies.companyList
    },

    async setDrawerOpen(isOpen: boolean) {
      this.drawerOpen = isOpen
    },
  },

  persist: {
    key: 'logus-saas',
    storage: window.localStorage,
  },
})
